const checkAddressProperties = (addressA, addressB) => {
  return Object.keys(addressA).every((key) => {
    if (key === 'residentialIndicator') {
      // only originAddresses have a residential indicator
      return true;
    }
    return addressA[key] === addressB[key];
  });
};

export const checkAddressEquality = (addressA, addressB) => {
  if ((!addressA && addressB) || (addressA && !addressB)) {
    return false;
  }
  return checkAddressProperties(addressA, addressB) && checkAddressProperties(addressB, addressA);
};
